module.exports = __webpack_public_path__ + "img/BrucePowerTag.5ad4872e.png";